import { render } from "./index.vue?vue&type=template&id=0813da1e&scoped=true&bindings={}"
import script from "./playlist-combiner.js?vue&type=script&lang=js"
export * from "./playlist-combiner.js?vue&type=script&lang=js"

import "./playlist-combiner.scss?vue&type=style&index=0&id=0813da1e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0813da1e"

export default script